<script lang="ts" setup>
import { useClaims } from '@auth';
import { menuQueries } from '@services/asp-c/queries/Menu';
import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { MenuItem } from '../../store/menu';
import MenuVertical from '../menu/MenuVertical.vue';

const props = defineProps<{
  customItems?: Array<MenuItem>;
  customLoadingState?: boolean;
  navigateInFrame?: boolean; // TODO: Alleen voor MenuVertical. Voor nieuw menu automatisch bepalen op basis van aanwezigheid menu-iframe
}>();

const claims = useClaims();

const menuItemQuery = useQuery({
  ...menuQueries.getMenuItems(),
  select: result => result.data.items,
  enabled: computed(() => claims.value?.isSuccess && !props.customItems)
});

const isLoading = computed(() => (props.customItems ? props.customLoadingState : menuItemQuery.isPending.value));
const menuItems = computed(() => props.customItems || menuItemQuery.data.value || []);
</script>

<template>
  <MenuVertical :is-loading="isLoading" :menu-items="menuItems" :navigate-in-frame="props.navigateInFrame" />
</template>
